import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import News from './pages/News';
import NewsArticle from './pages/NewsArticle';
import GettingStartedOnlineCasinosUk from './pages/guides/GettingStartedOnlineCasinosUk';
import UkGamblingRegulationsLicensing from './pages/guides/UkGamblingRegulationsLicensing';
import ChoosingRightOnlineCasino from './pages/guides/ChoosingRightOnlineCasino';
import RegistrationAccountVerification from './pages/guides/RegistrationAccountVerification';
import DepositsWithdrawalsSafely from './pages/guides/DepositsWithdrawalsSafely';
import BonusesWageringRequirements from './pages/guides/BonusesWageringRequirements';
import GameSelectionStrategiesTips from './pages/guides/GameSelectionStrategiesTips';
import ResponsibleGamblingPlayerProtection from './pages/guides/ResponsibleGamblingPlayerProtection';
import CustomerSupportProblemResolution from './pages/guides/CustomerSupportProblemResolution';
import NewUkGamblingRegulations2025 from './pages/news/NewUkGamblingRegulations2025';
import Top5SlotGames2025 from './pages/news/Top5SlotGames2025';
import CasinoBonusWageringRequirementsGuide from './pages/news/CasinoBonusWageringRequirementsGuide';
import UkOnlineCasinoMarketGrowth2025 from './pages/news/UkOnlineCasinoMarketGrowth2025';
import PaymentInnovationCryptocurrencyOptionsUk from './pages/news/PaymentInnovationCryptocurrencyOptionsUk';
import LiveDealerTechnologyRevolutionaryChanges from './pages/news/LiveDealerTechnologyRevolutionaryChanges';
import ResponsibleGamblingInitiativesNewTools from './pages/news/ResponsibleGamblingInitiativesNewTools';
import MobileGamingDominanceSmartphoneCasinoUsage from './pages/news/MobileGamingDominanceSmartphoneCasinoUsage';
import SlotGameProvidersNewPartnershipsUk from './pages/news/SlotGameProvidersNewPartnershipsUk';
import Reviews from './pages/Reviews';
import Placard from './pages/reviews/Placard';
import EightEightEight from './pages/reviews/EightEightEight';
import Betano from './pages/reviews/Betano';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/getting-started-online-casinos-uk" element={<GettingStartedOnlineCasinosUk />} />
        <Route path="/guides/uk-gambling-regulations-licensing" element={<UkGamblingRegulationsLicensing />} />
        <Route path="/guides/choosing-right-online-casino" element={<ChoosingRightOnlineCasino />} />
        <Route path="/guides/registration-account-verification" element={<RegistrationAccountVerification />} />
        <Route path="/guides/deposits-withdrawals-safely" element={<DepositsWithdrawalsSafely />} />
        <Route path="/guides/bonuses-wagering-requirements" element={<BonusesWageringRequirements />} />
        <Route path="/guides/game-selection-strategies-tips" element={<GameSelectionStrategiesTips />} />
        <Route path="/guides/responsible-gambling-player-protection" element={<ResponsibleGamblingPlayerProtection />} />
        <Route path="/guides/customer-support-problem-resolution" element={<CustomerSupportProblemResolution />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/new-uk-gambling-regulations-2025" element={<NewUkGamblingRegulations2025 />} />
        <Route path="/news/top-5-slot-games-2025" element={<Top5SlotGames2025 />} />
        <Route path="/news/casino-bonus-wagering-requirements-guide" element={<CasinoBonusWageringRequirementsGuide />} />
        <Route path="/news/uk-online-casino-market-growth-2025" element={<UkOnlineCasinoMarketGrowth2025 />} />
        <Route path="/news/payment-innovation-cryptocurrency-options-uk" element={<PaymentInnovationCryptocurrencyOptionsUk />} />
        <Route path="/news/live-dealer-technology-revolutionary-changes" element={<LiveDealerTechnologyRevolutionaryChanges />} />
        <Route path="/news/responsible-gambling-initiatives-new-tools" element={<ResponsibleGamblingInitiativesNewTools />} />
        <Route path="/news/mobile-gaming-dominance-smartphone-casino-usage" element={<MobileGamingDominanceSmartphoneCasinoUsage />} />
        <Route path="/news/slot-game-providers-new-partnerships-uk" element={<SlotGameProvidersNewPartnershipsUk />} />
        <Route path="/news/:slug" element={<NewsArticle />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/placard" element={<Placard />} />
        <Route path="/reviews/888" element={<EightEightEight />} />
        <Route path="/reviews/betano" element={<Betano />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
      </Routes>
    </Router>
  );
}

export default App;
